import styled from 'styled-components'

export const ForceScrollWrapper = styled.div`
  display: block;
  margin-top: 32px;
  width: calc(100vw - 90px);
`

export const ForceScrollContainer = styled.div`
  display: block;
  overflow-x: auto;
  width: 100%;
  max-width: 100vw;
  padding-bottom: 4px;
`

export const HeaderCategory = styled.div`
  flex-shrink: 0;
  width: 300px;
  padding-left: 8px;
  font-weight: bold;
`

export const HeaderPeriod = styled.div`
  width: 100px;
  text-align: right;
  padding-right: 12px;
  font-weight: bold;
  flex-shrink: 0;
`

export const HeaderTotal = styled.div`
  min-width: 100px;
  text-align: right;
  padding-right: 12px;
  font-weight: bold;
  flex-grow: 1;
`

export const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  min-width: 100%;
  font-size: 0.85rem;
`

export const ContentCategory = styled.div`
  flex-shrink: 0;
  width: 300px;
  padding-top: 8px;
  padding-bottom: 8px;
`

export const ContentMonth = styled.div`
  width: 100px;
  text-align: right;
  padding-right: 12px;
  flex-shrink: 0;
  padding-top: 8px;
  padding-bottom: 8px;
`

export const ContentTotal = styled.div`
  min-width: 100px;
  font-weight: bold;
  text-align: right;
  padding-right: 12px;
  flex-grow: 1;
  padding-top: 8px;
  padding-bottom: 8px;
`